import { render, staticRenderFns } from "./TaskCardHeader.vue?vue&type=template&id=9929330a&scoped=true"
import script from "./TaskCardHeader.vue?vue&type=script&lang=ts"
export * from "./TaskCardHeader.vue?vue&type=script&lang=ts"
import style0 from "./TaskCardHeader.vue?vue&type=style&index=0&id=9929330a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9929330a",
  null
  
)

export default component.exports